var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSparcs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Symbol_Zabo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 149.46 34.08 81.99 0 27.52 0 149.46",
    style: {
      fill: "#042E60"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.47 216 100 138.25 45.96 161.54 15.47 216",
    style: {
      fill: "#12397D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.01 0 0.71 157.3 53.62 130.48 99.38 75.13 82.01 0",
    style: {
      fill: "#12397D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.62 130.48 0.71 157.3 45.96 161.54 100 138.25 53.62 130.48",
    style: {
      fill: "#042E60"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparcs);
export default __webpack_public_path__ + "static/media/sparcs.4fe00becfc94434df40d271728da5161.svg";
export { ForwardRef as ReactComponent };